/**
 * A STATE, IN A WORD. 09 §9.5 A3: colour is never the only carrier of meaning.
 *
 * `LifecycleChip` is the same idea bound to one enum. This one takes the Hebrew already resolved by
 * `adminVocabulary.ts`, so a tenant status, a membership status, a connector status and a freshness
 * verdict all render identically and none of them can acquire a private colour scheme.
 *
 * The tone is CHROME. Nothing branches on it, the word is always present, and a reader who cannot
 * distinguish the colours loses nothing.
 */

import type { Tone } from '../api/adminVocabulary';

export interface StatusChipProps {
  readonly labelHe: string;
  readonly tone: Tone;
  /** Rendered as a title attribute for the pointer, never as the only place the meaning lives. */
  readonly detailHe?: string;
}

export function StatusChip({ labelHe, tone, detailHe }: StatusChipProps): JSX.Element {
  return (
    <span className="chip chip--status" data-tone={tone} {...(detailHe === undefined ? {} : { title: detailHe })}>
      {labelHe}
    </span>
  );
}
